import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'table-check-all',
  template: `
    <th>
      <input type="checkbox" ngModel #selectAll="ngModel" (change)="tableCheckAll(selectAll.value)" />
    </th>
  `,
  styles: [
    `
      input[type='checkbox'] {
        /* Double-sized Checkboxes */
        -ms-transform: scale(1.3); /* IE */
        -moz-transform: scale(1.3); /* FF */
        -webkit-transform: scale(1.3); /* Safari and Chrome */
        -o-transform: scale(1.3); /* Opera */
        transform: scale(1.3);
      }
    `,
  ],
  imports: [FormsModule],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class TableCheckAllComponent {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
  @Input() tableCheckAll: Function;
}
